var _text, _text2, _text3, _text4, _text5, _text6, _line, _line2, _line3, _line4, _line5, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 359,
    viewBox: "0 0 218 359",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 30,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Networth"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 90,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Goals & Expenses"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 150,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Post Retirement Income"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 205,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Risk Assesment"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 265,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Asset Allocation"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 325,
    fill: "#0B2653",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", null, "Portfolio Construction"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 46,
    x2: 33,
    y2: 68,
    stroke: "#27AE60",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 106,
    x2: 33,
    y2: 128,
    stroke: "#27AE60",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 164,
    x2: 33,
    y2: 186,
    stroke: "#27AE60",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 223,
    x2: 33,
    y2: 245,
    stroke: "#27AE60",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 282,
    x2: 33,
    y2: 304,
    stroke: "#B9C2D0",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 7C43.598 7 53 16.402 53 28C53 39.598 43.598 49 32 49C20.402 49 11 39.598 11 28C11 16.402 20.402 7 32 7ZM32 46.0802C41.9854 46.0802 50.0802 37.9854 50.0802 28C50.0802 18.0146 41.9854 9.91976 32 9.91976C22.0146 9.91976 13.9198 18.0146 13.9198 28C13.9198 37.9854 22.0146 46.0802 32 46.0802Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 66C43.598 66 53 75.402 53 87C53 98.598 43.598 108 32 108C20.402 108 11 98.598 11 87C11 75.402 20.402 66 32 66ZM32 105.08C41.9854 105.08 50.0802 96.9854 50.0802 87C50.0802 77.0146 41.9854 68.9198 32 68.9198C22.0146 68.9198 13.9198 77.0146 13.9198 87C13.9198 96.9854 22.0146 105.08 32 105.08Z",
    fill: "#27AE60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 125C43.598 125 53 134.402 53 146C53 157.598 43.598 167 32 167C20.402 167 11 157.598 11 146C11 134.402 20.402 125 32 125ZM32 164.08C41.9854 164.08 50.0802 155.985 50.0802 146C50.0802 136.015 41.9854 127.92 32 127.92C22.0146 127.92 13.9198 136.015 13.9198 146C13.9198 155.985 22.0146 164.08 32 164.08Z",
    fill: "#27AE60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 184C43.598 184 53 193.402 53 205C53 216.598 43.598 226 32 226C20.402 226 11 216.598 11 205C11 193.402 20.402 184 32 184ZM32 223.08C41.9854 223.08 50.0802 214.985 50.0802 205C50.0802 195.015 41.9854 186.92 32 186.92C22.0146 186.92 13.9198 195.015 13.9198 205C13.9198 214.985 22.0146 223.08 32 223.08Z",
    fill: "#27AE60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 243C43.598 243 53 252.402 53 264C53 275.598 43.598 285 32 285C20.402 285 11 275.598 11 264C11 252.402 20.402 243 32 243ZM32 282.08C41.9854 282.08 50.0802 273.985 50.0802 264C50.0802 254.015 41.9854 245.92 32 245.92C22.0146 245.92 13.9198 254.015 13.9198 264C13.9198 273.985 22.0146 282.08 32 282.08Z",
    fill: "#27AE60"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32 302C34.7578 302 37.4885 302.543 40.0364 303.599C42.5842 304.654 44.8992 306.201 46.8492 308.151C48.7993 310.101 50.3461 312.416 51.4015 314.964C52.4568 317.511 53 320.242 53 323H50.0802C50.0802 320.626 49.6126 318.275 48.704 316.081C47.7953 313.887 46.4636 311.894 44.7847 310.215C43.1058 308.536 41.1126 307.205 38.919 306.296C36.7254 305.387 34.3743 304.92 32 304.92L32 302Z",
    fill: "#A85CD7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_210_331)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 28,
    r: 16,
    fill: "#27AE60"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9394 31.6978L25.6258 28.3865C25.2534 28.0143 24.6517 28.0143 24.2793 28.3865C23.9069 28.7586 23.9069 29.3598 24.2793 29.732L28.271 33.7209C28.6434 34.093 29.245 34.093 29.6174 33.7209L39.7207 23.6247C40.0931 23.2525 40.0931 22.6513 39.7207 22.2791C39.3483 21.907 38.7466 21.907 38.3742 22.2791L28.9394 31.6978Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_210_331)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 87,
    r: 16,
    fill: "#27AE60"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_210_331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9394 90.6978L25.6258 87.3865C25.2534 87.0143 24.6517 87.0143 24.2793 87.3865C23.9069 87.7586 23.9069 88.3598 24.2793 88.732L28.271 92.7209C28.6434 93.093 29.245 93.093 29.6174 92.7209L39.7207 82.6247C40.0931 82.2525 40.0931 81.6513 39.7207 81.2791C39.3483 80.907 38.7466 80.907 38.3742 81.2791L28.9394 90.6978Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_210_331)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 146,
    r: 16,
    fill: "#27AE60"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_210_331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9394 149.698L25.6258 146.386C25.2534 146.014 24.6517 146.014 24.2793 146.386C23.9069 146.759 23.9069 147.36 24.2793 147.732L28.271 151.721C28.6434 152.093 29.245 152.093 29.6174 151.721L39.7207 141.625C40.0931 141.252 40.0931 140.651 39.7207 140.279C39.3483 139.907 38.7466 139.907 38.3742 140.279L28.9394 149.698Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_210_331)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 205,
    r: 16,
    fill: "#27AE60"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_210_331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9394 208.698L25.6258 205.386C25.2534 205.014 24.6517 205.014 24.2793 205.386C23.9069 205.759 23.9069 206.36 24.2793 206.732L28.271 210.721C28.6434 211.093 29.245 211.093 29.6174 210.721L39.7207 200.625C40.0931 200.252 40.0931 199.651 39.7207 199.279C39.3483 198.907 38.7466 198.907 38.3742 199.279L28.9394 208.698Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_210_331)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 264,
    r: 16,
    fill: "#27AE60"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_210_331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9394 267.698L25.6258 264.386C25.2534 264.014 24.6517 264.014 24.2793 264.386C23.9069 264.759 23.9069 265.36 24.2793 265.732L28.271 269.721C28.6434 270.093 29.245 270.093 29.6174 269.721L39.7207 259.625C40.0931 259.252 40.0931 258.651 39.7207 258.279C39.3483 257.907 38.7466 257.907 38.3742 258.279L28.9394 267.698Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_210_331)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 323,
    r: 16,
    fill: "#A85CD7"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0001 318.162H35.8001V316.296C35.8001 315.929 35.5001 315.629 35.1335 315.629H28.6001C28.2334 315.629 27.9334 315.929 27.9334 316.296V318.162H25C24.4334 318.162 24 318.629 24 319.162V321.729H40V319.162C40 318.629 39.5666 318.162 39 318.162H39.0001ZM29.2667 316.962H34.4667V318.162H29.2667V316.962Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8 324.059H36.1V322.859H27.9V324.059H26.2V322.859H24V329.359C24 329.893 24.4334 330.359 25 330.359H39C39.5667 330.359 40 329.893 40 329.359V322.859H37.8V324.059Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_210_331",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_331"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_331",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_210_331",
    x: 0,
    y: 59,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_331"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_331",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_210_331",
    x: 0,
    y: 118,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_331"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_331",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_210_331",
    x: 0,
    y: 177,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_331"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_331",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_210_331",
    x: 0,
    y: 236,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_331"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_331",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_210_331",
    x: 0,
    y: 295,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_331"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_331",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(22 18)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_210_331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(22 77)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_210_331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(22 136)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_210_331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(22 195)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_210_331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(22 254)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep6);
export default __webpack_public_path__ + "static/media/step_6.78df47cc91dee8a2bc472d995f75ba7a.svg";
export { ForwardRef as ReactComponent };